import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Research from "./pages/Research";
import PostDesigner from "./pages/PostDesigner";
import Adventures from "./pages/Adventures";

function PageTitleManager() {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      '/': 'Josh Rubow | Home',
      '/research': 'JR | Research',
      '/designer': 'JR | Designer',
      '/adventures': 'JR | Adventures'
    };

    document.title = titles[location.pathname] || 'Josh Rubow';
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <PageTitleManager />
      <div className="App">
        <Navbar />
        <div className="App-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/research" element={<Research />} />
            <Route path="/designer" element={<PostDesigner />} />
            <Route path="/adventures" element={<Adventures />} />
            <Route path="/adventures/:id" element={<Adventures />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;